import {connect} from 'react-redux';

import LocationManagerList from './LocationManagerList';
import LocationManagerItem from './LocationManagerItem';


const LocationManagerHistory = ({locations, editing, onSetEditable}) => {
    return (
        <LocationManagerList>
            {locations.map((location, index) => (
                <LocationManagerItem
                    key={location.id}
                    index={index}
                    location={location}
                    editing={location === editing}
                    onSetEditable={() => onSetEditable(location)}
                />
            ))}
        </LocationManagerList>
    )
};

const mapStateToProps = ({locations}) => ({
    locations: locations.history.map(id => locations[id]),
});

export default connect(mapStateToProps)(LocationManagerHistory);
